export enum IncompatibilitiesType {
  ARMADO = 'armado',
  DEFAULT_STOCK = 'defaultCantidad',
  PRODUCTO = 'producto',
  PARCIAL = 'parcial',
  CANTIDAD = 'cantidad',
  STOCK = 'stock',
  ENERGIA = 'energia',
  MANUAL = 'manual',
}
